import { Button, HStack, Text, useDisclosure } from "@chakra-ui/react";
import { Plural, t } from "@lingui/macro";
import type { TEvaluationComponentProps } from "@src/components/modules/projects/detail/Evaluation/types";
import { CardHeader } from "@src/components/modules/projects/detail/Stats/CardHeader";
import { useStore } from "@src/components/modules/projects/detail/Store";
import { Card } from "@src/components/ui-kit";
import { ModalInvoices } from "@src/components/widgets/Modals/ModalInvoices";
import { currency } from "@src/utils/formatters";
import { type FC, Fragment, type ReactNode } from "react";

type RowProps = {
  title: string;
  value: ReactNode;
};

export const BillingRow: FC<RowProps> = ({ title, value }) => {
  return (
    <HStack justifyContent="space-between" w="full">
      <Text>{title}</Text>
      <Text>{value}</Text>
    </HStack>
  );
};

export const BillingCard: FC<TEvaluationComponentProps> = ({ project }) => {
  const modalInvoices = useDisclosure();
  const { refetchProject } = useStore();
  const { unused_sum_from_proformas, gross_income, credit } = project.stats;

  return (
    <Fragment>
      <Card p="4">
        <CardHeader title={t`Revenue`} />
        <BillingRow
          title={t`Revenue (Total)`}
          value={currency.formatByWorkspace(credit + unused_sum_from_proformas)}
        />
        <BillingRow
          title={t`Gross Income`}
          value={currency.formatByWorkspace(gross_income)}
        />
        <BillingRow
          title={t`Invoiced total`}
          value={
            <Button onClick={modalInvoices.onOpen} variant="link">
              <Plural
                value={project?.invoiceAndPrepaymentCount || 0}
                one="# invoice"
                other="# invoices"
              />
            </Button>
          }
        />
      </Card>
      <ModalInvoices
        {...modalInvoices}
        projectId={project.id}
        onTransfer={refetchProject}
      />
    </Fragment>
  );
};
